import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { STORE_TYPE } from './risk-tolerances.model';
import { RiskTolerancesEffects } from './risk-tolerances.effects';
import { riskTolerancesReducer } from './risk-tolerances.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(STORE_TYPE, riskTolerancesReducer),
    EffectsModule.forFeature([RiskTolerancesEffects]),
  ],
})
export class UIRiskTolerancesStoreModule {}